<template>
    <div>
        <AprAlert v-editable="blok" :blok="blok" :message="message" :name="icon" :status="status" />
    </div>
</template>

<script lang="ts" setup>
import AprAlert from '~/components/sections/AprAlert.vue';
defineProps<{
    blok: any;
    message?: string;
    icon?: string;
    status?: 'error' | 'success' | 'warning' | undefined;
}>();
</script>

<style lang="postcss" scoped>
:deep(.alert) {
    @apply w-full;
}
</style>
